@let _type = type();
@let _loading = loading();

<div
  role="button"
  [attr.tabindex]="disabled ? -1 : 0"
  [attr.aria-label]="title || null"
  [attr.aria-disabled]="disabled"
  [attr.data-track]="trackEvent() || null"
  (click)="
    $event.stopPropagation();
    $event.stopImmediatePropagation();
    !disabled && click()
  "
  (keydown)="onKeydown($event)"
  (mousedown)="
    $event.stopPropagation();
    $event.stopImmediatePropagation();
    $event.preventDefault()
  "
  class="relative flex items-center justify-center transition-colors {{
    bgColor
      ? bgColor
      : _type === 'primary'
        ? 'bg-slate-700 hover:bg-slate-900'
        : _type === 'text'
          ? 'bg-transparent'
          : ''
  }} {{
    hoverColor
      ? hoverColor
      : (_type === 'default' || _type === 'text' || _type === 'outlined') &&
          !disableHover
        ? 'hover:bg-slate-200'
        : _type === 'danger-outlined'
          ? 'hover:bg-red-200'
          : _type === 'tertiary-outlined'
            ? 'hover:bg-tertiary-100'
            : ''
  }}"
  [ngClass]="{
    'cursor-pointer': !disabled,
    'rounded-md': square,
    'rounded-full': !square,
    'h-12 w-12': !autoHeigth && size === 'large',
    'h-8 w-8': !autoHeigth && size === 'base',
    'h-6 w-6': !autoHeigth && size === 'xs',
    'cursor-not-allowed opacity-50': disabled,
    'border border-slate-100': border,
    'border border-slate-200 hover:border-slate-400': _type === 'outlined',
    'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-600 focus-visible:ring-offset-1':
      !disabled
  }"
>
  <div
    class="absolute flex items-center justify-center transition-opacity inset-o"
    [ngClass]="{
      '-z-10 opacity-0': !_loading,
      'opacity-100': _loading
    }"
  >
    @if (_loading) {
      <i class="fa-light fa-spinner-third animate-spin"></i>
    }
  </div>

  @if (badge && badge > 0) {
    <div
      class="absolute -top-0.5 -right-0.5 z-30 flex rounded-full bg-red-600"
      style="width: 18px; height: 18px"
    >
      <div class="relative flex items-center justify-center flex-1">
        @if (badgeAnimated) {
          <div
            class="absolute inset-0 bg-red-400 rounded-full animate-ping"
          ></div>
        }

        <span class="text-white" style="font-size: 12px"
          >{{ badge > 9 ? "9+" : badge }}
        </span>
      </div>
    </div>
  }

  <i
    [sntTooltip]="title"
    aria-hidden="true"
    class="{{ icon }} transition-opacity {{
      _type === 'primary' && !textColor ? 'text-slate-100' : textColor || ''
    }}"
    [ngClass]="{
      'text-xs': size === 'xs',
      'text-3xl': size === '3xl',
      'opacity-0': _loading,
      'opacity-100': !_loading,
      'text-error': _type === 'danger-outlined',
      'text-tertiary-900': _type === 'tertiary-outlined'
    }"
  ></i>
</div>
